/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateSessionHandoffResult = {
  /**
   * When the link stops being served regardless of reads.
   */
  expiresAt: Date;
  /**
   * Capability URL serving the uploaded handoff markdown. Unauthenticated by design — the unguessable token is the credential — and dead after the first read or expiry.
   */
  url: string;
};

/** @internal */
export const CreateSessionHandoffResult$inboundSchema: z.ZodMiniType<
  CreateSessionHandoffResult,
  unknown
> = z.pipe(
  z.object({
    expires_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_at": "expiresAt",
    });
  }),
);

export function createSessionHandoffResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateSessionHandoffResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateSessionHandoffResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSessionHandoffResult' from JSON`,
  );
}
